import { Button } from '@mui/material';
import { Routes } from 'constants/pages';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

export const Success: React.FC = () => {
  const navigate = useNavigate();
  const onClick = () => {
    navigate(Routes.SignIn);
  };

  return (
    <Button variant="contained" onClick={onClick}>
      <h3>Sign in to your account</h3>
    </Button>
  );
};
